import * as React from "react";
import { TaskListItemWrapper } from "src/components/TaskListPanel/TaskList/TaskListItem/TaskListItem.components";
import EditTaskPanel from "src/components/TaskListPanel/TaskList/TaskListItem/EditTaskPanel/EditTaskPanel";
import TaskContentPanel from "src/components/TaskListPanel/TaskList/TaskListItem/TaskContentPanel/TaskContentPanel";

export interface Props {
  taskId: string;
  title: string;
  finalResult: string | null;
  isDeletingTask: boolean;
  toggleDeleteConfirmPanel: (isDeleting: boolean, taskKey?: string) => void;
  isEditingTask: boolean;
  toggleEditPanel: (isDeleting: boolean, taskKey?: string) => void;
}

const TaskListItem: React.FunctionComponent<Props> = ({
  taskId,
  title,
  finalResult,
  isDeletingTask,
  toggleDeleteConfirmPanel,
  isEditingTask,
  toggleEditPanel,
}) => (
  <TaskListItemWrapper>
    {isEditingTask ? (
      <EditTaskPanel
        taskId={taskId}
        title={title}
        toggleEditPanel={toggleEditPanel}
      />
    ) : (
      <TaskContentPanel
        taskId={taskId}
        title={title}
        finalResult={finalResult}
        isDeletingTask={isDeletingTask}
        toggleDeleteConfirmPanel={toggleDeleteConfirmPanel}
        toggleEditPanel={toggleEditPanel}
      />
    )}
  </TaskListItemWrapper>
);

export default TaskListItem;
